import React from 'react';
import Panel from 'components/v2/panels/Panel';
import classnames from 'classnames';
export default function Card({ title, className, children }) {
    return (React.createElement(Panel, { className: classnames(className) },
        React.createElement("div", { className: "flex items-center justify-between" },
            React.createElement("h3", null, title),
            children)));
}
